import { graphql, useStaticQuery } from 'gatsby';

function useWpPagesData() {
  const data = useStaticQuery(graphql`
    {
      contentfulPage(nameid: { eq: "Pages Page" }) {
        metaTitle
        metaDescription {
          metaDescription
        }
        heroSections: hero_sections {
          image {
            gatsbyImageData(
              quality: 100
              layout: CONSTRAINED
              placeholder: TRACED_SVG
            )
            title
          }
          primaryTitle
          primaryDescription {
            primaryDescription
          }
        }
      }
      allWpPage {
        nodes {
          seo {
            readingTime
          }
          title
          date(formatString: "MMM DD, YYYY")
          slug
          featuredImage {
            node {
              localFile {
                childImageSharp {
                  gatsbyImageData(placeholder: BLURRED, height: 100, width: 200)
                }
              }
            }
          }
          author {
            node {
              avatar {
                url
                size
              }
              firstName
              lastName
              nickname
              description
              username
            }
          }
        }
      }
    }
  `);
  return data;
}

export default useWpPagesData;
